import { IAboutDetails } from '@/interfaces/IAboutUsData';
import styles from './PowerofFourSection.module.css';
import Image from 'next/image';
import { useState, useEffect } from 'react';
type props = {
    powerOfFour: IAboutDetails
}
export function PowerofFourSection({ powerOfFour }: props) {
    return <section className="power_four_warp">
        <div className="container">
            <h2 className="sectionHeading  mb20">Power of 4</h2>
            <p className={`font18 fontThin ${styles.subHeading}`} style={{marginBottom:`40px`}}>We at Nirvasa follow a holistic approach to wellbeing that integrates 4 Wellness Pillars, helping to understand individual concerns and recommend personalized treatments.</p>
            <div className={styles.fourPowerBox}>
                {powerOfFour.power_of_4_image.map((f, idx) =>
                    <div className={styles.colum_box_power} key={idx}>
                        <Image src={f.image} alt={f.content} width={595} height={340} className="img-fluid" />
                        <h3 className="font30 textfff">{f.content}</h3>
                    </div>
                )}
            </div>
        </div>
    </section>
}